import React from "react";
import { TESTIMONIALS } from "./data";
import { useRevealGroup } from "../../hooks/useReveal";

const Testimonials = () => {
  const ref = useRevealGroup(".reveal");
  return (
    <section
      ref={ref}
      className="py-24 lg:py-32"
      style={{ backgroundColor: "#FAF6EF" }}
      data-testid="testimonials-section"
    >
      <div className="max-w-[1340px] mx-auto px-6 lg:px-12">
        <div className="reveal max-w-[720px] mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="block w-10 h-px" style={{ backgroundColor: "#0A3728" }} />
            <span
              className="font-ui uppercase track-eyebrow"
              style={{ fontSize: 9, color: "#0A3728", letterSpacing: "0.48em" }}
            >
              Client Stories
            </span>
            <span className="block w-10 h-px" style={{ backgroundColor: "#0A3728" }} />
          </div>
          <h2
            className="font-display font-medium leading-[1.05]"
            style={{ fontSize: "clamp(38px, 5vw, 60px)", color: "#0A0A0A" }}
          >
            Relationships{" "}
            <span
              className="font-italic italic font-normal"
              style={{ color: "#0A3728" }}
            >
              Beyond Transactions
            </span>
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              className={`reveal delay-${i + 1} relative pt-12 px-2`}
              data-testid={`testimonial-${i}`}
            >
              <span
                aria-hidden
                className="absolute -top-4 left-0 font-italic italic font-medium leading-none"
                style={{ fontSize: "84px", opacity: 0.55, color: "#0A3728" }}
              >
                &ldquo;
              </span>
              <blockquote
                className="font-body italic text-[17px] leading-[1.75]"
                style={{ color: "#0A0A0A" }}
              >
                {t.quote}
              </blockquote>
              <span
                className="block w-8 h-px mt-7"
                style={{ backgroundColor: "#0A3728" }}
              />
              <figcaption className="mt-5">
                <div
                  className="font-ui uppercase track-label font-medium"
                  style={{ fontSize: 11, color: "#0A0A0A" }}
                >
                  {t.name}
                </div>
                <div
                  className="font-ui font-light mt-1"
                  style={{ fontSize: 11, color: "#8C7E6A" }}
                >
                  {t.detail}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
